<!--P075-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'ProducePriceManage'})">成本调价查询</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">成本调价详情</div>
    </div>
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">成本调价单详情</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">成本调价单号</div>
      <div class="cs_radius_lg txt_info_search">{{detailInfo.num}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">制单人</div>
      <div class="cs_radius_lg txt_info_search">{{detailInfo.staffName}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">制单日期</div>
      <div class="cs_radius_lg txt_info_search ui_margin_left_30">{{detailInfo.date}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">配送中心</div>
      <div class="cs_radius_lg txt_info_search">{{detailInfo.dc}}</div>
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">备注</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm ui_margin_left_72 width_440">{{detailInfo.remarks}}</div>
    </div>
    <div class="cs_margin_top div_search_result cs_padding_top_lg">
      <div class="div_table">
        <table class="cs_table cs_td_divider_none cs_thead_fixed" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="151px">货品编号</th>
            <th width="280px">货品名称</th>
            <th width="100px">规格</th>
            <th width="130px">库存单位</th>
            <th width="184px">调前成本价</th>
            <th width="184px">调后成本价</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList">
            <td width="40px">{{index+1}}</td>
            <td width="151px">{{item.materialNum}}</td>
            <td width="280px">{{item.materialName}}</td>
            <td width="100px">{{item.materialSpecs}}</td>
            <td width="130px">{{item.unit}}</td>
            <td width="184px">{{item.oldPrice}}</td>
            <td width="184px">{{item.newPrice}}</td>
          </tr>
          <template v-if="PAGE_SIZE>orderList.length">
            <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
              <td width="40px"></td>
              <td width="151px"></td>
              <td width="280px"></td>
              <td width="100px"></td>
              <td width="130px"></td>
              <td width="184px"></td>
              <td width="184px"></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select"
  export default {
    name: "ProducePriceDetail",
    components: {WebSelect,SearchSelect},
    data: function () {
      return {
        detailInfo:{
          num:"",
          staffName:"",
          date:"",
          dc:"",
          remarks:"",
        },
        orderList: [],
        PAGE_SIZE:10
      }
    },
    created: function () {
      this.showDetail();
    },
    mounted: function() {
    },
    methods: {
      showDetail(){
        this.$ajax.priceManage.acquireProducePriceManageInfo.bind(this)(this.$route.query.id,(data) => {
          this.detailInfo={
            num: data.data.order.num,
            staffName: data.data.order.staffName,
            date: this.isEmpty(data.data.order.cstCreate)?"":data.data.order.cstCreate.substring(0,10),
            dc: data.data.order.dcName,
            remarks: data.data.order.remarks,
          };
          this.orderList = data.data.list;
        }, (data) => {
        }, true)
      },

      failDefault() {
      },
    },
  }
</script>

<style scoped>
  .width_440{
    width: 440px;
  }
  .cs_table tbody{max-height: 411px;}
</style>



// WEBPACK FOOTER //
// src/page/price/ProducePriceDetail.vue